export { default } from './BookCard';
